var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pending_icon",
    "data-name": "Pending icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending",
    transform: "translate(32 32) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 13,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16,0A16,16,0,1,0,32,16,16.006,16.006,0,0,0,16,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y2: 5.333,
    transform: "translate(24.957 24.957) rotate(135)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 5.333,
    transform: "translate(23.333 16)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 5.333,
    transform: "translate(24.956 7.043) rotate(45)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y2: 5.333,
    transform: "translate(16 3.333)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 5.333,
    transform: "translate(10.814 10.814) rotate(135)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 5.269,
    transform: "translate(3.397 16)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 5.333,
    transform: "translate(10.814 21.186) rotate(45)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 5.333,
    transform: "translate(16 23.333)",
    fill: "none",
    stroke: "#ae60ff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.40c70a80.svg";
export { ForwardRef as ReactComponent };